export interface TimezoneOption {
  value: string;
  label: string;
}

export const TIMEZONE_OPTIONS: TimezoneOption[] = [
  { value: 'UTC', label: 'UTC' },
  { value: 'Africa/Cairo', label: 'Africa/Cairo (GMT+02:00)' },
  { value: 'Asia/Dubai', label: 'Asia/Dubai (GMT+04:00)' },
  { value: 'Asia/Karachi', label: 'Asia/Karachi (GMT+05:00)' },
  { value: 'Asia/Kolkata', label: 'Asia/Kolkata (GMT+05:30)' },
  { value: 'Asia/Bangkok', label: 'Asia/Bangkok (GMT+07:00)' },
  { value: 'Asia/Singapore', label: 'Asia/Singapore (GMT+08:00)' },
  { value: 'Asia/Tokyo', label: 'Asia/Tokyo (GMT+09:00)' },
  { value: 'Australia/Sydney', label: 'Australia/Sydney (GMT+10:00)' },
  { value: 'Europe/London', label: 'Europe/London (GMT+00:00)' },
  { value: 'Europe/Paris', label: 'Europe/Paris (GMT+01:00)' },
  { value: 'Europe/Istanbul', label: 'Europe/Istanbul (GMT+03:00)' },
  { value: 'America/Sao_Paulo', label: 'America/Sao_Paulo (GMT-03:00)' },
  { value: 'America/New_York', label: 'America/New_York (GMT-05:00)' },
  { value: 'America/Chicago', label: 'America/Chicago (GMT-06:00)' },
  { value: 'America/Denver', label: 'America/Denver (GMT-07:00)' },
  { value: 'America/Los_Angeles', label: 'America/Los_Angeles (GMT-08:00)' }
];

export const detectUserTimezone = (): string => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  } catch {
    return 'UTC';
  }
};
